import type { TranslationObject } from '@/types';

import { deMessages } from './de';
import { enMessages } from './en';

export const translationMessages: Record<string, TranslationObject> = {
  'de-DE': deMessages,
  'en-GB': enMessages,
};
